"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardElements = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var connect_js_1 = require("@stripe/connect-js");
var react_connect_js_1 = require("@stripe/react-connect-js");
var axios_1 = __importDefault(require("axios"));
var inversify_react_1 = require("inversify-react");
var react_1 = __importStar(require("react"));
var StripeStyleVariables_1 = require("./StripeStyleVariables");
var styles = __importStar(require("./DashboardElements.css"));
var DashboardElements = function (_a) {
    var paymentGateway = _a.paymentGateway;
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var stripePublicConfig = (0, inversify_react_1.useInjection)("stripePublicConfig");
    var _b = __read((0, react_1.useState)(false), 2), showError = _b[0], setShowError = _b[1];
    var getStripeConnectInstance = function () {
        var _a;
        if (!paymentGateway) {
            return;
        }
        var publishableKey = (_a = stripePublicConfig[paymentGateway.countryCode]) === null || _a === void 0 ? void 0 : _a.publishableKey;
        if (!publishableKey) {
            setShowError(true);
            return;
        }
        var fetchClientSecret = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post("".concat(apiBaseUrl, "/payments/create-account-session"), { gatewayId: paymentGateway.id }, { withCredentials: true })];
                    case 1:
                        response = _a.sent();
                        setShowError(false);
                        return [2, response.data.client_secret];
                    case 2:
                        error_1 = _a.sent();
                        setShowError(true);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        return (0, connect_js_1.loadConnectAndInitialize)({
            publishableKey: publishableKey,
            fetchClientSecret: fetchClientSecret,
            appearance: {
                variables: StripeStyleVariables_1.variables,
            },
        });
    };
    var stripeConnectInstance = getStripeConnectInstance();
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", paddingTop: "m" }, stripeConnectInstance && !showError ? (react_1.default.createElement(react_connect_js_1.ConnectComponentsProvider, { connectInstance: stripeConnectInstance, key: paymentGateway === null || paymentGateway === void 0 ? void 0 : paymentGateway.id },
        react_1.default.createElement(react_connect_js_1.ConnectBalances, null),
        react_1.default.createElement(react_connect_js_1.ConnectPayments, null))) : (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center", className: styles.errorTextWrapper },
        react_1.default.createElement(kaleidoscope_1.Text, { className: styles.errorText }, showError
            ? "Something went wrong, please make sure the payment gateway is set up properly."
            : "Connect a payment gateway to proceed.")))));
};
exports.DashboardElements = DashboardElements;
